function SecondDiagnosisMeedyVO(id, status, creationDate, verificationDate, executionDate, height, weight, panelIdPatient, panelIdResource,
                                treatmentHistory, idOffer, description, diagnosis, rejectionReasons, idAttachments, child, patient, physicianStartProgressDate, type, gender,
                                result1Number, result1Date, result1Place, result2Number, result2Date, result2Place, result3Number, result3Date, result3Place) {

  this.id = id;
  this.status = status;
  this.creationDate = creationDate;
  this.verificationDate = verificationDate;
  this.executionDate = executionDate;
  this.height = height;
  this.weight = weight;
  this.panelIdPatient = panelIdPatient;
  this.panelIdResource = panelIdResource;
  this.treatmentHistory = treatmentHistory;
  this.idOffer = idOffer;
  this.description = description;
  this.diagnosis = diagnosis;
  this.rejectionReasons = rejectionReasons;
  this.idAttachments = idAttachments;
  this.child = child;
  this.patient = patient;
  this.gender = gender;
  this.physicianStartProgressDate = physicianStartProgressDate;
  this.type = type;
  this.result1Number = result1Number;
  this.result1Date = result1Date;
  this.result1Place = result1Place;
  this.result2Number = result2Number;
  this.result2Date = result2Date;
  this.result2Place = result2Place;
  this.result3Number = result3Number;
  this.result3Date = result3Date;
  this.result3Place = result3Place;


  var _typeContext = {
    creationDate : Date,
    result1Date : Date,
    result2Date : Date,
    result3Date : Date,
    verificationDate : Date,
    executionDate : Date,
		physicianStartProgressDate: Date,
    patient : PatientMeedyVO,
    treatmentHistory : TreatmentHistoryMeedyVO,
    rejectionReasons : SecondDiagnosisRejectionHistoryMeedyVO,
    child: ChildMeedyVO
  };

  this._getType = function (property) {
    if (_typeContext.hasOwnProperty(property)) {
      return _typeContext[property];
    }
    else {
      return undefined;
    }
  };

  var _mappingContext = {};

  this._getMapping = function (property) {
    if (_mappingContext[property]) {
      return _mappingContext[property];
    }
    else {
      return undefined;
    }
  };
}
